import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9f43e6d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add_role_view_bg" }
const _hoisted_2 = { class: "top_view" }
const _hoisted_3 = {
  class: "model-wrapper",
  style: {"overflow":"auto"}
}
const _hoisted_4 = { class: "ava-wrapper" }
const _hoisted_5 = ["onClick", "onMouseenter", "onMouseleave"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "bottom_view" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main-name" }, "默认人格", -1))
const _hoisted_9 = { class: "main-intro" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "submit_button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.submitClick && _ctx.submitClick(...args)))
      }, "确认")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.charactList, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.avatar,
            onClick: ($event: any) => (_ctx.selectCharact(item)),
            onMouseenter: ($event: any) => (_ctx.handleMouseEnter(index)),
            onMouseleave: ($event: any) => (_ctx.handleMouseLeave(index)),
            style: _normalizeStyle(_ctx.itemStyle(index))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass([
                item.characterId === _ctx.characterId ? 'active-border' : '',
                !item.allow ? 'disable_character' : ''])
            }, [
              _createElementVNode("img", {
                class: "avatar_img",
                src: item.avatar,
                alt: ""
              }, null, 8, _hoisted_6),
              _createElementVNode("div", {
                class: _normalizeClass(['level_style']),
                style: _normalizeStyle({ background: item.levelBackground })
              }, _toDisplayString(item.userLevelTips), 5)
            ], 2)
          ], 44, _hoisted_5))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.digitalIntroduction), 1)
    ])
  ]))
}